module.exports = __webpack_public_path__ + "media/photo/home_banner-a706c9ef.jpg";